<template>
  <v-dialog v-model="_active" @click:outside="_setActive(false)" width="1600">
    <v-card class="pa-4">
      <div class="d-flex justify-space-between">
        <v-card-text class="text-h5 mb-6">
          Ad JSON - Prebid Config ID
        </v-card-text>
        <v-btn
          class="white--text"
          :class="showMobileView ? '' : 'mr-5 mt-4'"
          color="secondary"
          width="100px"
          @click="_setActive(false)"
          >Done</v-btn
        >
      </div>
      <v-row>
        <ad-json-fields title="Banner" :data.sync="ads.banner" />
        <ad-json-fields title="Interstitial" :data.sync="ads.interstitial" />
        <ad-json-fields title="Rewarded Video" :data.sync="ads.rewardedVideo" />
        <ad-json-fields title="Home Banner" :data.sync="homeBanner" />
        <ad-json-fields title="Internal Banner" :data.sync="internalBanner" />
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import GroupDetailData from '@/mixins/GroupDetailData';
import AdJsonFields from '@/components/group-details/AdJsonFields';
import MobileView from '@/mixins/MobileView';

export default {
  mixins: [GroupDetailData, MobileView],
  components: {
    AdJsonFields,
  },
  data() {
    return {
      ads: {},
      adsSet: false,
    };
  },
  computed: {
    ...mapGetters({
      _active: 'groupDetails/getAdJson',
    }),
    homeBanner() {
      return [this.ads.homeBanner];
    },
    internalBanner() {
      return [this.ads.internalBanner];
    },
  },
  methods: {
    ...mapMutations({
      _setActive: 'groupDetails/setAdJson',
    }),
    setAds() {
      if (this.details.ad_json === '0') {
        this.ads = {};
      } else {
        this.ads = JSON.parse(
          this.details.ad_json.replace(
            /(['"])?([a-z0-9A-Z_]+)(['"])?:/g,
            '"$2": ',
          ),
        ).ads;
      }
    },
  },
  watch: {
    ads: {
      handler() {
        if (this.adsSet) {
          if (this.details.ad_json === '0') {
            this.details.ad_json = '{}';
          }
          const temp = JSON.parse(
            this.details.ad_json.replace(
              /(['"])?([a-z0-9A-Z_]+)(['"])?:/g,
              '"$2": ',
            ),
          );
          temp.ads = this.ads;
          this.details.ad_json = JSON.stringify(temp);
        } else {
          this.adsSet = true;
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.setAds();
    }, 1500);
  },
};
</script>
